(function () {
  'use strict';

  function workflowPathController($scope, $state, $timeout, workflowData, workflowStateService) {
      var vm = this;

      vm.workflowData = workflowData;

      $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        vm.stateParams = toParams;
        var object = workflowStateService.getRouteDataFromPath(vm.workflowData, toParams.path);

        switch (object.route) {
          case ('workflow.roadmap'):
            $state.go('workflow.roadmap', { workflowId: vm.workflowData.Id.split('/')[1], path: toParams.path });
            break;
          case ('workflow.navigator.phase'):
            $state.go('workflow.navigator.phase', { workflowId: vm.workflowData.Id.split('/')[1], phaseIndex: object.phaseIndex, path: toParams.path });
            break;
          case ('workflow.internalfiles'):
              $state.go('workflow.internalfiles', { workflowId: vm.workflowData.Id.split('/')[1], path: toParams.path });
              break;
        }
      });
  }

  workflowPathController.$inject = ['$scope', '$state', '$timeout', 'workflowData', 'workflowStateService'];

  angular.module('ecap.workflow').controller('workflowPathController', workflowPathController);
})();
